import { NativeStackScreenProps } from "@react-navigation/native-stack";
import { useCallback } from "react";
import { SettingsRootParamList } from "../../../../types";
import { SetupLocation } from "../../../setup/components/SetupLocation";

export type SelectLocationSettingScreenProps = NativeStackScreenProps<
  SettingsRootParamList,
  "SelectLocationSettingScreen"
>;

export const SelectLocationSettingScreen = ({
  navigation,
}: SelectLocationSettingScreenProps) => {
  const onSwitchLocation = useCallback(() => {
    navigation.goBack();
  }, []);
  return <SetupLocation afterSubmit={onSwitchLocation} />;
};
